import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

const FAQ_DATA = [
  {
    q: (
      <FormattedMessage
        id="ae-faq1"
        defaultMessage="🚗💵 Save Money Every Mile"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq1A"
        defaultMessage="EVs are cheaper to operate than gas cars. Electricity costs less than gasoline, and EVs use energy more efficiently, helping you go farther for less. "
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-faq2"
        defaultMessage="🛠️ Less Maintenance, More Peace of Mind "
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq2A"
        defaultMessage="No oil changes. Fewer moving parts. EVs require less upkeep, saving you time and money on repairs."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-faq3"
        defaultMessage="😊 A Better Driving Experience"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq3A"
        defaultMessage="Experience the thrill of instant acceleration and responsive handling. EVs are quiet, powerful, and incredibly fun to drive—whether you're commuting or enjoying a weekend cruise."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-faq4"
        defaultMessage="🌿🏙️ Cleaner for the Community "
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq4A"
        defaultMessage="EVs produce no tailpipe emissions, which means cleaner air and fewer greenhouse gases in our city. By choosing electric, you are actively contributing to Austin's climate goals."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-faq5"
        defaultMessage="🔌🏠🛣️ Charge at Home or On the Go"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq5A"
        defaultMessage="Plug in overnight at home or use the growing network of public charging stations around Austin, including fast chargers."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-faq6"
        defaultMessage="🎁 Get Rewarded to Drive Electric"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-faq6A"
        defaultMessage="Take advantage of federal tax credits and Austin Energy rebates to make EV ownership even more affordable. If you are like most people and drive around 30 miles a day, an EV could mean more money in your pocket and more time for what matters."
      />
    ),
  },
];

const Chevron = ({ expanded }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    style={{
      transition: 'transform 180ms ease',
      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    }}
  >
    <path
      d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
      fill="currentColor"
    />
  </svg>
);

const FAQItem = ({ idBase, index, q, a, expanded, onToggle }) => {
  const buttonId = `${idBase}-faq-button-${index}`;
  const panelId = `${idBase}-faq-panel-${index}`;

  return (
    <div className="faq-item border rounded-3 mb-2">
      <h3 className="m-0">
        <button
          id={buttonId}
          className="faq-trigger w-100 d-flex align-items-center justify-content-between text-start p-3 border-0 bg-white"
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={onToggle}
        >
          <span className="pe-3">{q}</span>
          <Chevron expanded={expanded} />
        </button>
      </h3>

      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        hidden={!expanded}
        className="faq-panel px-3 pb-3"
      >
        <p className="mb-0">{a}</p>
      </div>
    </div>
  );
};

const HomepageFAQ = () => {
  const [open, setOpen] = useState(() => new Set());
  const idBase = useRef(
    `faq-${Math.random().toString(36).slice(2, 9)}`
  ).current;

  const toggle = (i) =>
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });

  return (
    <section
      className="homepage-faq-container container"
      aria-label="Homepage FAQ"
    >
      <div className="faq-title">
        <h2 className="mb-2">
          <FormattedMessage
            id="faqTitle"
            defaultMessage="Why Drive Electric?"
          />
        </h2>
        <p>
          <FormattedMessage
            id="faqDescription"
            defaultMessage="Driving an EV comes with great benefits — for your wallet, your driving experience, and the environment."
          />
        </p>
      </div>

      <div className="faq-list mt-4">
        {FAQ_DATA.map((item, i) => (
          <FAQItem
            key={i}
            idBase={idBase}
            index={i}
            q={item.q}
            a={item.a}
            expanded={open.has(i)}
            onToggle={() => toggle(i)}
          />
        ))}
      </div>

      <style>{`
        .faq-item:hover .faq-trigger { background-color: #f8f9fa; }
        .faq-trigger { font-size: 1rem; }
        .faq-panel { background-color: #fff; }
      `}</style>
    </section>
  );
};

export default HomepageFAQ;
